import { render, staticRenderFns } from "./BaseKeywordHistoryModal.vue?vue&type=template&id=3f1eea8e&scoped=true"
import script from "./BaseKeywordHistoryModal.vue?vue&type=script&lang=js"
export * from "./BaseKeywordHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./BaseKeywordHistoryModal.vue?vue&type=style&index=0&id=3f1eea8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1eea8e",
  null
  
)

export default component.exports